module.exports = __webpack_public_path__ + "media/sessions/all_hands@3x-427fffb8.png";